import React, { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Megaphone, BarChart3, TrendingUp, Plug, CalendarDays, Sparkles } from "lucide-react";
import OverviewTab from "./tabs/OverviewTab";
import LeadsTab from "./tabs/LeadsTab";
import ProfitabilityTab from "./tabs/ProfitabilityTab";
import IntegrationsTab from "./tabs/IntegrationsTab";
import EditorialTab from "./tabs/EditorialTab";
import AssistantTab from "./tabs/AssistantTab";
import AuditTab from "./tabs/AuditTab";
import DirectorTab from "./tabs/DirectorTab";

export default function MarketingPage() {
  const [tab, setTab] = useState("overview");
  return (
    <div className="space-y-6" data-testid="marketing-page">
      <header className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-xl flex items-center justify-center bg-[#E6F2FF] text-[#0A2A5E] border border-[#CCE2F8]">
          <Megaphone size={24} />
        </div>
        <div className="flex-1">
          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900 dark:text-slate-50">Marketing</h1>
          <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">
            Captación, atribución y rentabilidad de expediciones. Datos reales — nunca inventados.
          </p>
        </div>
      </header>

      <Tabs value={tab} onValueChange={setTab} className="w-full">
        <TabsList className="w-full flex flex-wrap gap-1 h-auto bg-white dark:bg-[#131B2A] border border-slate-200 dark:border-[#25334D] p-1 rounded-xl">
          <TabsTrigger value="overview" className="flex-1 min-w-[140px] data-[state=active]:bg-[#0A2A5E] data-[state=active]:text-white" data-testid="mkt-tab-overview">
            <BarChart3 size={14} className="mr-2" /> Resumen
          </TabsTrigger>
          <TabsTrigger value="leads" className="flex-1 min-w-[140px] data-[state=active]:bg-[#0A2A5E] data-[state=active]:text-white" data-testid="mkt-tab-leads">
            <Megaphone size={14} className="mr-2" /> Leads &amp; UTM
          </TabsTrigger>
          <TabsTrigger value="profit" className="flex-1 min-w-[140px] data-[state=active]:bg-[#0A2A5E] data-[state=active]:text-white" data-testid="mkt-tab-profit">
            <TrendingUp size={14} className="mr-2" /> Rentabilidad
          </TabsTrigger>
          <TabsTrigger value="integrations" className="flex-1 min-w-[140px] data-[state=active]:bg-[#0A2A5E] data-[state=active]:text-white" data-testid="mkt-tab-integrations">
            <Plug size={14} className="mr-2" /> Integraciones
          </TabsTrigger>
          <TabsTrigger value="editorial" className="flex-1 min-w-[140px] data-[state=active]:bg-[#0A2A5E] data-[state=active]:text-white" data-testid="mkt-tab-editorial">
            <CalendarDays size={14} className="mr-2" /> Calendario
          </TabsTrigger>
          <TabsTrigger value="ai" className="flex-1 min-w-[140px] data-[state=active]:bg-[#0A2A5E] data-[state=active]:text-white" data-testid="mkt-tab-ai">
            <Sparkles size={14} className="mr-2" /> Director IA
          </TabsTrigger>
          <TabsTrigger value="audit" className="flex-1 min-w-[140px] data-[state=active]:bg-[#0A2A5E] data-[state=active]:text-white" data-testid="mkt-tab-audit">
            <Sparkles size={14} className="mr-2" /> Auditoría
          </TabsTrigger>
        </TabsList>

        <TabsContent value="overview" className="mt-6"><OverviewTab /></TabsContent>
        <TabsContent value="leads" className="mt-6"><LeadsTab /></TabsContent>
        <TabsContent value="profit" className="mt-6"><ProfitabilityTab /></TabsContent>
        <TabsContent value="integrations" className="mt-6"><IntegrationsTab /></TabsContent>
        <TabsContent value="editorial" className="mt-6"><EditorialTab /></TabsContent>
        <TabsContent value="ai" className="mt-6"><DirectorTab /></TabsContent>
        <TabsContent value="audit" className="mt-6"><AuditTab /></TabsContent>
      </Tabs>
    </div>
  );
}
